/* @ngInject */
function customerConfigurationsService (ConnectorWebService, CONSTANTS, Utils) {
  var service = {
    getAllConfigurations,
    updateAllConfigurations,
    getOneConfigurationByType,
    getCompanyStatusAndTrial,
    updateCompanyStatusAndTrial,
    getFeatureConfigurations,
    getFeatureDetailsConfigurations,
    updateCustomerConfiguration,
    updateStringConfiguration
  }
  return service

  function getAllConfigurations () {
    return ConnectorWebService.get(CONSTANTS.URL_CUSTOMER_CONFIGURATIONS)
  }

  function getFeatureConfigurations () {
    return ConnectorWebService.get(CONSTANTS.URL_CUSTOMER_CONFIGURATION_FEATURES)
  }

  function getFeatureDetailsConfigurations (featureType) {
    const url = Utils.fnAddQueryToUrl(CONSTANTS.URL_CUSTOMER_CONFIGURATION_FEATURE_DETAILS, { featureType })
    return ConnectorWebService.get(url)
  }

  function getCompanyStatusAndTrial () {
    return ConnectorWebService.get(CONSTANTS.URL_CUSTOMER_CONFIGURATION_COMPANY_STATUS)
  }

  function updateCompanyStatusAndTrial (params) {
    return ConnectorWebService.put(CONSTANTS.URL_CUSTOMER_CONFIGURATION_COMPANY_STATUS, params)
  }

  function updateAllConfigurations (configurations) {
    return ConnectorWebService.put(CONSTANTS.URL_CUSTOMER_CONFIGURATIONS, configurations)
  }

  function updateStringConfiguration (configurations) {
    return ConnectorWebService.put(CONSTANTS.URL_CUSTOMER_CONFIGURATION_STRING, configurations)
  }

  function getOneConfigurationByType (type, dataType, customerCompanyId) {
    const key = 'URL_' + dataType + '_CONFIGURATION_TYPE'
    let url = Utils.fnReplaceStringParams(CONSTANTS[key], [type])
    url = Utils.fnAddQueryToUrl(url, { customerCompanyId })

    return ConnectorWebService.get(url)
  }

  function updateCustomerConfiguration (payload) {
    return ConnectorWebService.put(CONSTANTS.URL_CUSTOMER_CONFIGURATION_CONFIG, payload)
  }
}

export { customerConfigurationsService }
